export function createPromise<T = any>(): { resolver: (resolvedData?: T) => void; promise: Promise<T> } {
	let resolver = () => {}
	const promise = new Promise<T>((_resolver) => (resolver = _resolver))
	return {
		resolver,
		promise,
	}
}
